import createTableStore from "ds/components/Table/store/useTableStore";

import { AZURE_TABLE_COLUMNS_CONFIG, AZURE_TABLE_STORAGE_KEY } from "../../constants";

const useIntegrationsAzureTableStore = createTableStore({
  storageKey: AZURE_TABLE_STORAGE_KEY,
  config: AZURE_TABLE_COLUMNS_CONFIG,
});

export default useIntegrationsAzureTableStore;
